import api from './api';

const passwordService = {
    // Create a new password
    createPassword(passwordData) {
        return api.post('/passwords', passwordData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }).catch(async (error) => {
        if (error.response?.status === 401) {
          await authService.refreshToken();
          return api.post('/passwords', passwordData, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          });
        }
        throw error;
      });
    },

    // Get all passwords
    getAllPasswords() {
        return api.get('/passwords', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }).catch(async (error) => {
        if (error.response?.status === 401) {
          await authService.refreshToken();
          return api.get('/passwords', {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          });
        }
        throw error;
      });
    },

    // Get a specific password by ID
    getPasswordById(id) {
        return api.get(`/passwords/${id}`);
    },

    // Update a password
    updatePassword(id, passwordData) {
        return api.put(`/passwords/${id}`, passwordData);
    },

    // Delete a password
    deletePassword(id) {
        return api.delete(`/passwords/${id}`);
    },

    // Get passwords by class ID
    getPasswordsByClass(classId) {
        return api.get(`/passwords/class/${classId}`);
    },
  async upsertPassword(data) {
    try {
      const response = await api.post('/passwords/upsert', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default passwordService;